import Menus from "../Menus";

const HelpTopicFonctionnementVersements = () => {
  const goBackLinks = [
    { label: 'Accueil', link: '/'},
    { label: 'Tous les sujets', link: '/topics'},
    { label: 'Versements', link: '/topics/versements'},
    { label: "Fonctionnement des versements", link: '/topics/versements/fonctionnment-versements'}, 
  ]
    
  const multiMenus = [
    {title: null, filter: 'HelpTopicFonctionnementVersements'},
  ]

  return <Menus goBackLinks={goBackLinks} multiMenus={multiMenus}/>
}

export default HelpTopicFonctionnementVersements